import { gql } from 'apollo-boost'

const SET_MENU_CLUSTER_ASSIGNABLE = gql`
  mutation setMenuClusterAssignable($id: ID!, $isClusterAssignable: Boolean!) {
    setMenuClusterAssignable(
      id: $id
      isClusterAssignable: $isClusterAssignable
    ) {
      id
      isClusterAssignable
    }
  }
`

export default SET_MENU_CLUSTER_ASSIGNABLE
